import React from 'react';
import PropTypes from 'prop-types';
import { useOverlay, DismissButton, FocusScope } from 'react-aria';
import s from './Popover.module.scss';
/**
 * A popover based on react-aria from Adobe
 * Taken from https://react-spectrum.adobe.com/react-aria/useComboBox.html
 * @param {object} props - component props
 * @returns {object} - component jsx
 */
function Popover(props) {
  const ref = React.useRef();
  const { popoverRef = ref, isOpen, onClose, children } = props;

  // Handle events that should cause the popup to close,
  // e.g. blur, clicking outside, or pressing the escape key.
  const { overlayProps } = useOverlay(
    {
      isOpen,
      onClose,
      shouldCloseOnBlur: true,
      isDismissable: true,
    },
    popoverRef
  );

  // Add a hidden <DismissButton> component at the end of the popover
  // to allow screen reader users to dismiss the popup easily.
  return (
    <FocusScope restoreFocus>
      <div
        /* eslint-disable-next-line react/jsx-props-no-spreading */
        {...overlayProps}
        ref={popoverRef}
        className={s.popover}
      >
        <DismissButton onDismiss={onClose} />
        {children}
      </div>
    </FocusScope>
  );
}

Popover.propTypes = {
  popoverRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default Popover;
